const STORAGE_KEY = 'geniusmind_pending_book_referral';

// Fallback attribution for a visitor who clicks a book referral link before
// they're logged in — the code is re-submitted to /referrals/track once
// they authenticate (see context/useAuthStore.js).
export function getPendingReferral() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setPendingReferral(code, bookId) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, bookId }));
  } catch {
    // Storage unavailable (private mode, quota) — attribution just won't
    // survive a login redirect; not worth surfacing to the user.
  }
}

export function clearPendingReferral() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // See setPendingReferral.
  }
}
